import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import { useStore } from '../../lib/context'

import { observer } from 'mobx-react-lite'
import { motion } from 'framer-motion'
import css from 'styled-jsx/css'

import { Carrot } from './'

const CommunityDropdown = observer(() => {
	const {
		uiStore: {
			updateMapActiveFilterMobile,
			map__activeFilterMobile,
			updateNavBarTextColor,
			directory__mobileMenuOpen,
			toggleMobileDirectoryMenu,
		},
	} = useStore()

	return (
		<>
			<div onClick={toggleMobileDirectoryMenu} className="links">
				<div className="link">Community</div>

				<Link to={'/business/'}>
					<div className="link" style={{ opacity: 0.4 }}>
						Business
					</div>
				</Link>

				<Link to={'/being/'}>
					<div className="link" style={{ opacity: 0.4 }}>
						Being
					</div>
				</Link>
				
				<Link to={'/being/'}>
					<div className="link" style={{ opacity: 0.4 }}>
						Beyond
					</div>
				</Link>
			</div>

			<Carrot />

			<style jsx>{`
				@media only screen and (max-width: 768px), (pointer: coarse) {
					.links {
						display: flex;
						flex-direction: column;
					}
					.link {
						font-family: 'Elizeth';
						font-weight: 500;
						color: black;
						text-transform: uppercase;
						padding-right: 0.625rem;
						font-size: var(--font--xs);
						height: var(--nav-bar-height-mobile);
						display: flex;
						justify-content: flex-end;
						align-items: center;
						cursor: pointer;
					}
				}
			`}</style>
		</>
	)
})

export default CommunityDropdown
